import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * A hook that determines the ReturnTypeEnum based on the current URL pathname.
 * Used to set the appropriate return type when creating a draft return.
 *
 * @returns The appropriate ReturnTypeEnum based on the current URL path
 */
export function useReturnType(): ReturnTypeEnum | undefined {
  const location = useLocation();
  const [returnType, setReturnType] = useState<ReturnTypeEnum | undefined>(
    undefined,
  );

  useEffect(() => {
    const pathname = location.pathname;

    // Check for specific URL patterns
    const isClaim = pathname.includes("/claim");
    const isWarranty = pathname.includes("/warranty");
    const isReturn = pathname.includes("/return");

    // Determine the return type
    if (isClaim) {
      setReturnType(ReturnTypeEnum.CLAIM);
    } else if (isWarranty) {
      setReturnType(ReturnTypeEnum.WARRANTY);
    } else if (isReturn) {
      setReturnType(ReturnTypeEnum.RETURN);
    }
  }, [location]);

  return returnType;
}
